import { DECREMENT } from '../constants/actionTypes'

const decrement = () => ({
  type: DECREMENT
})

export default decrement



/** WEBPACK FOOTER **
 ** ./src/actions/decrement.js
 **/